import React from 'react';
import PropTypes from 'prop-types';
import { SlashContainer } from '@zolteam/axenergie-ui-library';
import { useMeasure } from 'react-use';
import colors from '../../constants/Colors';
import strings from '../../constants/Strings';
import useIsMobile from '../../hooks/useIsMobile';

const GoodReasonsBlock = ({
  illustrationPath, color, intro, reasons,
}) => {
  const [isMobile] = useIsMobile();
  const [goodReasonContainerRef, { height: goodReasonContainerHeight }] = useMeasure();
  const getGoodReasonBlockIllustrationPath = () => (
    `${process.env.NEXT_PUBLIC_IMAGE_PREFIX_URL}/public/${illustrationPath}`
  );
  return (
    <div className={`d-flex ${isMobile ? 'f-column' : 'f-row'} bgIndex`}>
      <div className={isMobile ? 'baseIndex' : 'index-2'}>
        <SlashContainer
          width={isMobile ? '100%' : '100'}
          offset={isMobile ? 0 : 20}
          backgroundColor={color}
        >
          <div style={{
            height: isMobile ? 45 : goodReasonContainerHeight,
          }}
          />
        </SlashContainer>
      </div>
      <div
        className="fgIndex"
        style={{
          marginLeft: isMobile ? 0 : 100,
          marginTop: isMobile ? -40 : 0,
          width: isMobile ? '100%' : '50%',
        }}
      >
        <SlashContainer
          width="100%"
          backgroundColor={colors.white}
          offset={20}
          position={isMobile ? 'top' : 'slash'}
        >
          <div ref={goodReasonContainerRef} className="ph-3 d-flex f-column ml-4">
            <span
              className="h1 bold mt-5"
              style={{ color }}
            >
              {strings.fiveGoodReasons}
            </span>
            <span className="h2 medium-weight grey-800-text mv-3">
              {intro}
            </span>
            <div className="mb-5">
              {
                reasons.map(({ reason }, index) => (
                  <div
                      // eslint-disable-next-line react/no-array-index-key
                    key={`reason-${index}`}
                    className="d-flex f-row align-center mv-3"
                  >
                    <div
                      className="circle d-flex justify-center align-center mr-3"
                      style={{
                        backgroundColor: color,
                        width: 24,
                        minWidth: 24,
                        height: 24,
                        minHeight: 24,
                      }}
                    >
                      <span className="white-text">{index + 1}</span>
                    </div>
                    <span className="grey-800-text h6 normal-weight">{reason}</span>
                  </div>
                ))
            }
            </div>
          </div>
        </SlashContainer>
      </div>
      {
          isMobile ? null
            : (
              <div
                className="baseIndex d-flex align-center justify-end"
                style={{
                  width: '50%',
                  backgroundColor: color,
                }}
              >
                <div
                  style={{
                    height: goodReasonContainerHeight,
                    width: 'calc(100% - 40px)',
                  }}
                >
                  {/* eslint-disable-next-line @next/next/no-img-element */}
                  <img
                    alt="five-good-reasons"
                    src={getGoodReasonBlockIllustrationPath()}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                </div>

              </div>
            )
        }
    </div>
  );
};

GoodReasonsBlock.propTypes = {
  illustrationPath: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  intro: PropTypes.string.isRequired,
  reasons: PropTypes.arrayOf(PropTypes.shape({
    reason: PropTypes.string,
  })).isRequired,
};

export default GoodReasonsBlock;
